<template>
  <v-container fluid>

    <v-tabs v-model="tab" height="59" color="#fff" flat class="firstBar fixed-bar ma-0 pa-0">
      <v-tab href="#tab-1" class="tab" active-class="tab_color" color="#0482fb">Cotation service commercial </v-tab>
      <v-tab href="#tab-2" active-class="tab_color">Cotation direction technique</v-tab>

    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <v-data-table class="pt-3" flat :loading="loading ? '#0482fb' : null" :headers="quotingHeaders2"
          :search="cotingSearchData" :items="QuotingRequests.docs" :items-per-page="5" sort-by="">
          <!-- <template v-slot:item.status="{ item }">
            <td>
              {{ item.status === "Terminer" ? "Terminé" : item.status }}
            </td>
          </template>
          <template v-slot:item.name="{ item }">
            <td>
              {{ item.file.name }}
            </td>
          </template>
          <template v-slot:item.product="{ item }">
            <td>
              {{ item.product.name }}
            </td>
          </template> -->

          <template v-slot:top> <v-container fluid>
              <v-expansion-panels flat style="border: 1px solid #0482fb">
                <v-expansion-panel class="elevation-0">
                  <v-expansion-panel-header>
                    Tri / Recherche ...
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Date demande cotation début" class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" v-model="periodStartDate" type="date" dense flat
                          background-color="grey lighten-4"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Date demande cotation fin" class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" v-model="periodEndDate" type="date" dense flat
                          background-color="grey lighten-4"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-autocomplete outlined color="#0482fb" :items="userFile" class="pt-5 pa-2 mx-2"
                          prepend-inner-icon="mdi-magnify" v-model="fileName" dense flat
                          background-color="grey lighten-4" label="Nom raison social">
                        </v-autocomplete>
                      </v-col>
                      <!-- <v-col cols="12" md="3">
                        <v-text-field outlined color="#0482fb" label="Nom / Raison Sociale ..." class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" v-model="fileName" dense flat
                          background-color="grey lighten-4"></v-text-field>
                      </v-col> -->
                      <v-col cols="12" md="3">
                        <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                          dense v-model="product" flat background-color="grey lighten-4" label="Produit"></v-select>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-select outlined :items="items" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                          v-model="status" dense flat background-color="grey lighten-4" label="Statut"></v-select>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#0482fb" pill class="mr-2 white--text" @click="onEnter">
                        <v-icon left>
                          mdi-magnify
                        </v-icon>
                        Appliquer la recherche
                      </v-btn>
                    </v-card-actions>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
            <v-toolbar flat>
              <h4 class="text-h4 pageTitle ">Listing des cotations</h4>
              <!-- <v-toolbar-title></v-toolbar-title> -->
              <v-divider class="mx-4" inset vertical></v-divider>

              <v-switch v-model="showAllFil" label="Afficher toutes les données" color="#0482fb"
                @change="showAllFillData" class="pt-5"></v-switch>
              <v-spacer></v-spacer>

              <v-dialog v-model="userDialog" max-width="500px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-form>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field outlined dense flat color="#0482fb" v-model="Quoting.name"
                              label="Nom"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field outlined color="#0482fb" v-model="userModal.firstName"
                              label="Prénoms"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field outlined color="#0482fb" v-model="userModal.email"
                              label="Email"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field outlined color="#0482fb" v-model="editedItem.carbs"
                              label="Carbs (g)"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field outlined color="#0482fb" v-model="editedItem.protein"
                              label="Protein (g)"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="white--text ma-2" color="blue darken-1" text @click="close">
                      Cancel
                    </v-btn>
                    <v-btn class="white--text ma-2" color="blue darken-1" text @click="save">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5">Etes vous sûrs de vouloire supprimer cet élément
                    ?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="white--text ma-2" color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn class="white--text ma-2" color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>

          </template>
          <!-- <template v-slot:item.actions="{ item }">
          <v-icon color="warning" @click="editItem(item)">
            mdi-pencil-box-multiple-outline
          </v-icon>

          <v-btn class="white--text ma-2" icon class="ml-10" :to="`/cotation/${item._id}`">
            <v-icon color="success" size="30"
              >mdi-arrow-right-circle-outline</v-icon
            >
          </v-btn>
        </template> -->
          <template v-slot:item="{ item }">
            <tr @click="handleClick(item)" class="green-bg">
              <td>
                {{ item.actions }}
                <v-menu elevation="0" right offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                      <v-icon color="success" size="30">mdi-forwardburger</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-tooltip bottom color="warning">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ml-3" icon>
                          <v-icon size="20" @click="editItem(item)" v-bind="attrs" v-on="on"
                            color="warning">mdi-pencil-box-multiple-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Modification des informations de demande de cotation</span>
                    </v-tooltip>
                    <v-tooltip bottom color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ml-3" icon>
                          <v-icon @click="customerModalFunction(item)" v-bind="attrs" v-on="on" size="20"
                            color="primary">mdi-account-arrow-down</v-icon>
                        </v-btn>
                      </template>
                      <span>Retour client</span>
                    </v-tooltip>

                    <!-- <v-tooltip bottom color="grey darken-4">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ml-3" icon>
                          <v-icon
                            size="20"
                            color="grey darken-4"
                            v-bind="attrs"
                            v-on="on"
                            @click="medicalReport(item)"
                            >mdi-vector-link</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Rapport d'expertise médical</span>
                    </v-tooltip> -->
                  </v-list>
                </v-menu>
              </td>
              <td>
                <v-chip :color="getColor(item.status)" dark>
                  {{ item.status }}
                </v-chip>
              </td>
              <td>
                {{ item.file ? item.file.name : "" }}
              </td>

              <td>
                {{
                  item.product ? item.product.name : " "
                }}
              </td>
              <td>{{ item.createdAtFr }}</td>
              <td>{{ item.technicalDirectionQuotingRequestDate }}</td>
              <td>{{ item.returnDateFr }}</td>
              <td>{{ item.customerSendDateFr }}</td>
              <td>{{ item.customerReturnDateFr }}</td>

            </tr>
          </template>

        </v-data-table>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-data-table class="pt-3" flat :loading="loading ? '#0482fb' : null" :headers="quotingHeaders2"
          :search="cotingSearchData" :items="QuotingRequests.docs" :items-per-page="5" sort-by="">


          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Listing des cotations</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>

              <v-switch v-model="showAllFil" label="Afficher toutes les données" color="#0482fb"
                @change="showAllFillData" class="pt-5"></v-switch>
              <v-spacer></v-spacer>

              <v-dialog v-model="userDialog" max-width="500px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-form>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field outlined dense flat color="#0482fb" v-model="Quoting.name"
                              label="Nom"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field outlined color="#0482fb" v-model="userModal.firstName"
                              label="Prénoms"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field outlined color="#0482fb" v-model="userModal.email"
                              label="Email"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field outlined color="#0482fb" v-model="editedItem.carbs"
                              label="Carbs (g)"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field outlined color="#0482fb" v-model="editedItem.protein"
                              label="Protein (g)"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="white--text ma-2" color="blue darken-1" text @click="close">
                      Cancel
                    </v-btn>
                    <v-btn class="white--text ma-2" color="blue darken-1" text @click="save">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5">Etes vous sûrs de vouloire supprimer cet élément
                    ?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="white--text ma-2" color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn class="white--text ma-2" color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
            <v-container fluid>
              <v-expansion-panels flat style="border: 1px solid #0482fb">
                <v-expansion-panel class="elevation-0">
                  <v-expansion-panel-header>
                    Tri / Recherche ...
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Date demande cotation début" class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" v-model="periodStartDate" type="date" dense flat
                          background-color="grey lighten-4"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Date demande cotation fin" class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" v-model="periodEndDate" type="date" dense flat
                          background-color="grey lighten-4"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field outlined color="#0482fb" label="Nom / Raison Sociale ..." class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" v-model="fileName" dense flat
                          background-color="grey lighten-4"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                          dense v-model="product" flat background-color="grey lighten-4" label="Produit"></v-select>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-select outlined :items="items" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                          v-model="status" dense flat background-color="grey lighten-4" label="Statut"></v-select>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#0482fb" pill class="mr-2" @click="onEnter">
                        <v-icon left>
                          mdi-magnify
                        </v-icon>
                        Appliquer la recherche
                      </v-btn>
                    </v-card-actions>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
          </template>
          <!-- <template v-slot:item.actions="{ item }">
          <v-icon color="warning" @click="editItem(item)">
            mdi-pencil-box-multiple-outline
          </v-icon>

          <v-btn class="white--text ma-2" icon class="ml-10" :to="`/cotation/${item._id}`">
            <v-icon color="success" size="30"
              >mdi-arrow-right-circle-outline</v-icon
            >
          </v-btn>
        </template> -->
          <template v-slot:item="{ item }">
            <tr @click="handleClick(item)" class="green-bg">
              <td>
                {{ item.actions }}
                <v-menu elevation="0" right offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                      <v-icon color="success" size="30">mdi-forwardburger</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-tooltip bottom color="success">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ml-3" icon>
                          <v-icon size="20" color="success" v-bind="attrs" v-on="on"
                            @click="quotingModalFunction(item)">mdi-cash-multiple</v-icon>
                        </v-btn>
                      </template>
                      <span> Mise en place Cotation</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ml-3" icon>
                          <v-icon size="20" v-bind="attrs" v-on="on"
                            @click="companyModalFunction(item)">mdi-domain</v-icon>
                        </v-btn>
                      </template>
                      <span>Retour compagnie</span>
                    </v-tooltip>
                    <!-- <v-tooltip bottom color="grey darken-4">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ml-3" icon>
                          <v-icon
                            size="20"
                            color="grey darken-4"
                            v-bind="attrs"
                            v-on="on"
                            @click="medicalReport(item)"
                            >mdi-vector-link</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Rapport d'expertise médical</span>
                    </v-tooltip> -->
                  </v-list>
                </v-menu>
              </td>
              <td>
                <v-chip :color="getColor(item.status)" dark>
                  {{ item.status }}
                </v-chip>
              </td>
              <td>
                {{ item.file ? item.file.name : "" }}
              </td>

              <td>
                {{
                  item.product ? item.product.name : " "
                }}
              </td>
              <td>{{ item.createdAtFr }}</td>
              <td>{{ item.technicalDirectionQuotingRequestDate }}</td>
              <td>{{ item.returnDateFr }}</td>
              <td>{{ item.customerSendDateFr }}</td>
              <td>{{ item.customerReturnDateFr }}</td>

            </tr>
          </template>

        </v-data-table>
      </v-tab-item>
    </v-tabs-items>


    <!-- cotation modification-->
    <v-dialog v-model="returnDate" max-width="1000px">
      <v-card style="border-top: 10px solid #0482fb">
        <v-card-title>
          <span class="text-h5">Enregistrer la synthèse de cotation</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field outlined color="#0482fb" label="Nom / Raison Sociale" v-model="Quoting.name"
                  disabled></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field outlined color="#0482fb" label="Nom produit" v-model="Quoting.product"
                  disabled></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field outlined color="#0482fb" label="Date retour demande cotation" v-model="Quoting.returnDate"
                  type="date"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field outlined color="#0482fb" label="Date envoi client" v-model="Quoting.customerSendDate"
                  type="date"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field outlined color="#0482fb" disabled label="Date retour client" v-model="Quoting.customerReturnDate"
                  type="date"></v-text-field>
              </v-col>
              <v-col cols="12">

                <quill-editor ref="editor" v-model="Quoting.observation" class="mt-5" label="Corps du mail"
                  :options="editorOption" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="white--text ma-2" color="error " text @click="returnDate = false">
            fermer
          </v-btn>
          <v-btn class="white--text ma-2" color="success" @click="onConfirmQuotationRequestDate">Enregistrer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  Pop up des Cotation-->
    <template>
      <v-dialog v-model="quotingDialog" overlay max-width="1000px" transition="dialog-bottom-transition" scrollable>
        <cotationModalComponent @closeDialog="closeQuoting" v-if="quotingDialog"
          :QuotingRequestData="Object.assign({}, this.fileObject)" />
      </v-dialog>
    </template>
    <!--  Pop up des company return-->
    <template>
      <v-dialog v-model="companyDialog" overlay max-width="1000px" transition="dialog-bottom-transition" scrollable>
        <companyModalComponent v-if="companyDialog" :QuotingRequestData="Object.assign({}, this.fileObject)" />
      </v-dialog>
    </template>
    <!--  Pop up des customer-->
    <template>
      <v-dialog v-model="customerDialog" overlay max-width="1000px" transition="dialog-bottom-transition" scrollable>
        <customerModalComponent @close="closeCustomerModal" v-if="customerDialog"
          :QuotingRequestData="Object.assign({}, this.fileObject)" />
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import {
  addAgency,
  updateAgency,
  deleteAgency,
  updateProduct,
  addProduct,
  deleteProduct,
  updateCompany,
  addCompany,
  deleteCompany,
} from "@/api/admin";
import cotationModalComponent from "../components/modal/cotation.vue";
import companyModalComponent from "../components/modal/compagnyReturn.vue";
import customerModalComponent from "../components/modal/customerModal.vue";
import { updateQuotingRequest } from "@/api/user";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.snow.css";
export default {
  name: "cotation",
  components: {
    cotationModalComponent,
    companyModalComponent,
    customerModalComponent,
    quillEditor
  },
  data: () => ({
    dialog: false,
    loading: false,
    returnDate: false,
    productNameList: [],
    customerDialog: false,
    companyDialog: false,
    quotingDialog: false,
    AgencyDialog: false,
    tab: null,
    dialogDelete: false,
    headersAgency: [
      {
        text: "Nom de l'argence",
        align: "start",
        value: "name",
      },
      { text: "Localité", value: "country" },
      { text: "Téléphone", value: "phone" },
      { text: "Mail", value: "email" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    headersUsers: [
      {
        text: "Nom",
        align: "start",
        sortable: false,
        value: "lastName",
      },
      { text: "Prénoms", value: "firstName" },
      { text: "Téléphone", value: "phone" },
      { text: "Mail", value: "email" },
      { text: "Agence", value: "agency" },
      { text: "Poste", value: "currentPosition" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    headersProduct: [
      {
        text: "Nom du produit",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Abréviation", value: "acronym" },
      { text: "Description", value: "description" },
      { text: "Rapels avis échéance", value: "dueDate" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    cotingSearchData: "",
    quotingHeaders2: [
      {
        text: "Actions",
        width: "150px",
        align: "left",
        value: "actions",
        sortable: false,
      },
      { text: "Statut", width: "200px", value: "status" },
      { text: "Nom / Raison Sociale", width: "200px", value: "name" },
      {
        text: "Nom du produit",
        width: "200px",
        align: "start",
        value: "product",
      },
      { text: "Date demande cotation SCI", width: "200px", value: "createdAtFr" },
      { text: "Date demande cotation DT", width: "200px", value: "technicalDirectionQuotingRequestDate" },
      {
        text: "Date retour demande cotation",
        width: "250px",
        value: "returnDateFr",
      },
      {
        text: "Date envoi client",
        width: "200px",
        value: "customerSendDateFr",
      },
      {
        text: "Date retour client",
        width: "200px",
        value: "customerReturnDateFr",
      },
      // { text: "Observation", width: "200px", value: "observation" },
    ],
    Quoting: [
      {
        name: "gras savoye",
        product: "Automobile",
        quotingRequestDate: "22/08/2022",
        returnDate: "31/12/2022",
        customerSendDate: "31/12/2022",
        customerReturnDate: "31/12/2022",
        status: "Encours",
        observation: "Prévision d'affaire nouvelle",
      },
    ],
    editedIndex: -1,
    editedItem: {
      nom: "",
      localisation: "",
      telephone: "",
      mail: "",
    },
    defaultItem: {
      nom: "",
      localisation: "",
      telephone: "",
      mail: "",
    },

    loader: false,
    agencyModal: {},
    agencyDeleteDialog: false,
    userModal: {},
    items: ["*", "Envoie compagnie exécutée", "Demande cotation SCl", "Retour compagnie", "Envoie client", "Retour client"],
    productModal: {},
    productDialog: false,
    productDeleteDialog: false,

    companyModal: {},
    companyDeleteDialog: false,

    userDialog: false,
  }),

  computed: {
    ...mapGetters([
      "Agencies",
      "Quoting",
      "Users",
      "Products",
      "Companies",
      "QuotingRequests",
      "QuotingRequest",
      "Files"
    ]),
    AgencyForm() {
      return this.editedIndex === -1 ? "Ajouter Agence" : "Modifier Agence";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    Files() {
      this.userFile = defaultMethods.getNameList(this.Files.docs);
    },
    Products() {
      // alert('ok')
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
  },

  created() {
    this.initialize();
  },
  mounted() {
    // this.initAgencies();
    // this.initUsers();
    // this.initProducts();
    // this.initCompanies();
    this.initQuotingRequest();
  },

  methods: {
    ...mapActions([
      "getAgencies",
      "getUsers",
      "getProducts",
      "getCompanies",
      "getQuotingRequests",
      "getFiles",
      "getQuotingRequest",
      "getQuotingSearchRequests",
    ]),
    closeCustomerModal() {
      this.customerDialog = false;
    },
    initialize() {
      this.agencies = [
        {
          nom: "Gras Savoye Direction Bénin",
          localisation: "Cadjehou CNSAD",
          telephone: "62178726",
          mail: "testmail@contact.com",
        },
      ];
    },
    showAllFillData() {
      this.initQuotingRequest();
      //alert(this.showAllFil);
    },
    async initQuotingRequest() {
      this.loading = true;
      try {
        await this.getQuotingRequests({ withoutPeriod: this.showAllFil });
        await this.getProducts({ name: this.searchData });
        await this.getFiles({ withoutPeriod: true });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
    closeQuoting() {
      this.quotingDialog = false;
    },
    async onConfirmQuotationRequestDate() {
      this.loading = true;

      try {
        const schema = {
          observation: this.Quoting.observation,
          returnDate: this.Quoting.returnDate,
          customerSendDate: this.Quoting.customerSendDate,
          // customerReturnDate: this.Quoting.customerReturnDate,
        };

        // add
        await updateQuotingRequest({ schema, id: this.Quoting._id });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("Demande cotation")
        );
        this.returnDate = false;
        this.Quoting = {};
        this.initQuotingRequest();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    // agency
    async initAgencies() {
      this.loading = true;
      try {
        await this.getAgencies();
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les agences")
        );
      }
      this.loading = false;
    },
    closeAgencyForm() {
      this.agencyModal = {};
      this.productModal = {};
      this.companyModal = {};
      this.AgencyDialog = false;
      this.agencyDeleteDialog = false;
      this.productDialog = false;
      this.productDeleteDialog = false;
      this.companyDialog = false;
      this.companyDeleteDialog = false;
      this.editedIndex = -1;
    },
    async makeSearchContract() {
      this.loading = true;
      try {
        await this.getQuotingSearchRequests({
          fileName: this.fileName,
          product: this.product,
          periodStartDate: this.periodStartDate,
          periodEndDate: this.periodEndDate,
          withoutPeriod: this.showAllFil,
          status: this.status === "Terminé" ? "Terminer" : this.status,
          //setUpContract: true,
          //contractEstablished: false,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },
    onEnter: function () {
      this.makeSearchContract();
    },
    async saveAgencyForm() {
      this.loading = true;
      try {
        if (this.agencyModal.id) {
          // update
          await updateAgency({
            schema: {
              name: this.agencyModal.name,
              country: this.agencyModal.country,
              phone: this.agencyModal.phone,
              email: this.agencyModal.email,
            },
            id: this.agencyModal.id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("L'agence")
          );
          this.closeAgencyForm();
          this.initAgencies();
        } else {
          // add
          await addAgency(this.agencyModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("L'agence")
          );
          this.closeAgencyForm();
          this.initAgencies();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    getColor(item) {
      if (item == "Envoie compagnie exécutée") return "orange";
      else if (item == "Demande cotation SCl") return "green";
      else if (item == "Retour compagnie") return "yellow";
      else if (item == "Envoie client") return "blue";
      else if (item == "Retour client") return "pink";
      else return "green";
    },
    editAgency(item) {
      this.editedIndex = 1;
      this.agencyModal = {
        name: item.name,
        id: item._id,
        country: item.country,
        phone: item.phone,
        email: item.email,
      };
      this.AgencyDialog = true;
    },
    initDeleteAgency(id) {
      this.agencyModal = {
        id,
      };
      this.agencyDeleteDialog = true;
    },
    async confirmDeleteAgency() {
      this.loading = true;
      try {
        // add
        await deleteAgency({
          id: this.agencyModal.id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.deletedSuccessfully("L'agence")
        );
        this.closeAgencyForm();
        this.initAgencies();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // product
    async initProducts() {
      this.loading = true;
      try {
        await this.getProducts({ name: this.searchData });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les produits")
        );
      }
      this.loading = false;
    },
    async saveProductForm() {
      this.loading = true;
      try {
        if (this.productModal.id) {
          // update
          await updateProduct({
            schema: {
              name: this.productModal.name,
              description: this.productModal.description,
              acronym: this.productModal.acronym,
              dueDate: this.productModal.dueDate,
            },
            id: this.productModal.id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Le produit")
          );
          this.closeAgencyForm();
          this.initAgencies();
        } else {
          // add
          await addProduct(this.productModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Le produit")
          );
          this.closeAgencyForm();
          this.initProducts();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    editProduct(item) {
      this.editedIndex = 1;
      this.productModal = {
        name: item.name,
        id: item._id,
        description: item.description,
        dueDate: item.dueDate,
        acronym: item.acronym,
      };
      this.productDialog = true;
    },
    initDeleteProduct(id) {
      this.productModal = {
        id,
      };
      this.productDeleteDialog = true;
    },
    async confirmDeleteProduct() {
      this.loading = true;
      try {
        // add
        await deleteProduct({
          id: this.productModal.id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.deletedSuccessfully("Le produit")
        );
        this.closeAgencyForm();
        this.initAgencies();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },

    // company
    async initCompanies() {
      this.loading = true;
      try {
        await this.getCompanies();
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les compagnies")
        );
      }
      this.loading = false;
    },
    async saveCompanyForm() {
      this.loading = true;
      try {
        if (this.companyModal.id) {
          // update
          await updateCompany({
            schema: {
              name: this.companyModal.name,
              country: this.companyModal.country,
              email: this.companyModal.email,
              service: this.companyModal.service,
              nomination: this.companyModal.nomination,
              responsibleName: this.companyModal.responsibleName,
            },
            id: this.companyModal.id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("La compagnie")
          );
          this.closeAgencyForm();
          this.initCompanies();
        } else {
          // add
          await addCompany(this.companyModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("La compagnie")
          );
          this.closeAgencyForm();
          this.initCompanies();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    editCompany(item) {
      this.editedIndex = 1;
      this.companyModal = {
        id: item._id,
        name: item.name,
        country: item.country,
        email: item.email,
        service: item.service,
        nomination: item.nomination,
        responsibleName: item.responsibleName,
      };
      this.companyDialog = true;
    },
    initDeleteCompany(id) {
      this.companyModal = {
        id,
      };
      this.companyDeleteDialog = true;
    },
    async confirmDeleteCompany() {
      this.loading = true;
      try {
        // add
        await deleteCompany({
          id: this.companyModal.id,
        });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.deletedSuccessfully("La compagnie")
        );
        this.closeAgencyForm();
        this.initCompanies();
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    // user
    async initUsers() {
      this.loading = true;
      try {
        await this.getUsers();
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les utilisateurs")
        );
      }
      this.loading = false;
    },

    editItem(item) {
      this.editedIndex = 1;
      this.Quoting = {
        name: item.file.name,
        product: item.product.name,
        _id: item._id,
        customerSendDate: item.customerSendDate,
        customerReturnDate: item.customerReturnDate,
        observation: item.observation,
        returnDate: item.returnDate,
      };
      // this.editedItem = Object.assign({}, item);
      this.returnDate = true;
    },

    deleteItem(item) {
      this.editedIndex = this.agencies.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.agencies.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.agencies[this.editedIndex], this.editedItem);
      } else {
        this.agencies.push(this.editedItem);
      }
      this.close();
    },

    getFileFunction(item) {
      return new Promise((resolve, reject) => {
        this.getQuotingRequest(item)
          .then((res) => {
            this.fileObject = this.QuotingRequest;
            resolve(true);
            console.log(res);
          })
          .catch((error) => {
            this.fileObject = {};
            reject(error);
          });
      });
    },
    async quotingModalFunction(item) {
      await this.getFileFunction(item._id);
      this.quotingDialog = true;
    },
    // //call
    // async appelsModalFunction(item) {
    //   this.getFileFunction(item._id);

    //   this.appelsModal = true;
    // },
    //RDV
    companyModalFunction(item) {
      this.getFileFunction(item._id);

      this.companyDialog = true;
    },
    //product
    customerModalFunction(item) {
      this.getFileFunction(item._id);

      this.customerDialog = true;
    },
  },
};
</script>
<style>
.tab_color {
  border-top: 5px solid #0482fb !important;
  color: #0482fb !important;
}

.illustrationCenter {
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-top: 400;
  display: flex;
  margin-top: 20px;
}

.tab {
  border-bottom: 0px solid #fff !important;
}

.btnDesign {
  color: #fff;
}

.space {
  margin-left: -100px;
  margin-right: -100px;
}

.pageTitle {
  font-size: 10px;
  font-weight: bold;
  color: #0482fb;
}

.green-bg {
  /* Set the display to `table-row` because Vuetify makes `flex` */
  display: table-row;
}

td {
  font-size: 12px !important;
  border-bottom: 1px solid #f4f7fe !important;
}

.green-bg:hover {
  /* `!important` is necessary here because Vuetify overrides this */
  background: #0482fb !important;
  color: white;
  height: 70px;
  animation: -45deg;
  cursor: pointer;
  box-shadow: inset 0 0 1em #0482fb, 0 0 2em #eeeeee;
}
</style>